/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Mute_MembersInputs */



/**
* | output |
* | --- |
* | "Mute Members" |
*
* @param {Leveling_Perm_Mute_MembersInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_mute_members = /** @type {((inputs?: Leveling_Perm_Mute_MembersInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Mute_MembersInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отключать микрофоны участникам")
	return /** @type {LocalizedString} */ ("Mute Members")
});